import { render } from "./InformationOutline.vue?vue&type=template&id=9449021c"
import script from "./InformationOutline.vue?vue&type=script&lang=js"
export * from "./InformationOutline.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/InformationOutline.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9449021c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9449021c', __exports__)) {
    api.reload('9449021c', __exports__)
  }
  
  module.hot.accept("./InformationOutline.vue?vue&type=template&id=9449021c", () => {
    api.rerender('9449021c', render)
  })

}


export default __exports__